import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getSupplierSlice = createAsyncThunk(
  "supplier/getSupplier",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/supplier/getSupplier", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getSupplierByIdSlice = createAsyncThunk(
  "supplier/getSupplierById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/supplier/getSupplierById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addSupplierSlice = createAsyncThunk(
  "supplier/addSupplier",
  async (data, { rejectWithValue }) => {
    console.log(data);

    try {
      const response = await axios.post("/supplier/addSupplier", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateSupplierSlice = createAsyncThunk(
  "supplier/updateSupplier",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/supplier/updateSupplier", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteSupplierSlice = createAsyncThunk(
  "supplier/deleteSupplier",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/supplier/deleteSupplier", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
const initialState = {
  loading: false,
  supplier: [],
  supplierById: [],
  isLoading: false,
  addSupplierSuccessMessage: null,
  addSupplierErrorMessage: null,
  updateSupplierSuccessMessage: null,
  updateSupplierErrorMessage: null,
  deleteSupplierSuccessMessage: null,
  deleteSupplierErrorMessage: null,
  searchSupplierErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  reducers: {
    resetAddSupplierMessage: (state) => {
      state.addSupplierSuccessMessage = null;
      state.addSupplierErrorMessage = null;
    },
    resetUpdateSupplierMessage: (state) => {
      state.updateSupplierSuccessMessage = null;
      state.updateSupplierErrorMessage = null;
    },
    resetDeleteSupplierMessage: (state) => {
      state.deleteSupplierSuccessMessage = null;
      state.deleteSupplierErrorMessage = null;
    },
    resetSearchSupplierMessage: (state) => {
      state.searchSupplierErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplierSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.supplier = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchSupplierErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.supplier = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchSupplierErrorMessage = null;
      })
      .addCase(getSupplierSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchSupplierErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getSupplierByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplierByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.supplierById = action.payload.result.list;
      })
      .addCase(getSupplierByIdSlice.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addSupplierSlice.pending, (state) => {
        state.loading = true;
        state.addSupplierSuccessMessage = null;
        state.addSupplierErrorMessage = null;
      })
      .addCase(addSupplierSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.addSupplierErrorMessage = action.payload.result.message;
        } else {
          state.addSupplierSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(addSupplierSlice.rejected, (state, action) => {
        state.loading = false;
        state.addSupplierErrorMessage = action.payload.result.message;
      })
      .addCase(updateSupplierSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSupplierSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateSupplierSuccessMessage = action.payload.result.message;
        } else {
          state.updateSupplierErrorMessage = action.payload.result.message;
        }
      })
      .addCase(updateSupplierSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteSupplierSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteSupplierSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteSupplierSuccessMessage = action.payload.result.message;
        } else {
          state.deleteSupplierErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteSupplierSlice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const {
  resetAddSupplierMessage,
  resetUpdateSupplierMessage,
  resetDeleteSupplierMessage,
  resetSearchSupplierMessage,
} = supplierSlice.actions;

export default supplierSlice.reducer;
